module.exports = __webpack_public_path__ + "img/inspiration-book.b2e34cbd.svg";